<template>
  <div class="grow">
    <div v-if="booking && allocation">
      <h2>
        {{ t('returnOverview') }}
      </h2>

      <BasicReturnOverview :booking="booking" />

      <Divider />

      <VehicleAndTimes :booking-or-allocation="allocation" :car="allocation.car" />

      <Divider />

      <div class="flex justify-end">
        <ButtonNext @click.prevent="handleNext">{{ t('next') }}</ButtonNext>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import VehicleAndTimes from '@/components/booking-forms/VehicleAndTimes.vue';
import ButtonNext from '@/components/buttons/ButtonNext.vue';
import Divider from '@/components/Divider.vue';
import { useI18n } from 'vue-i18n';
import { useBooking } from '@/queries/use-bookings';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { VEHICLE_INSPECTION_FLAG } from '@/components/inspections/inspection-state';
import BasicReturnOverview from '../return/return-overview/components/BasicReturnOverview.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const { data: booking } = useBooking(route.params.bookingId as string);
const inspectionFlag = useFeatureFlag(VEHICLE_INSPECTION_FLAG);
const allocation = computed(() => {
  return booking.value?.allocations.find((allocation) => allocation.id === route.query.swapFromId);
});

const handleNext = async () => {
  if (!booking.value || !allocation.value) return;
  router.push({
    name: inspectionFlag.value ? 'swapReturnInspection' : 'swapReturnStatus',
    params: {
      bookingId: booking.value.id,
    },
    query: {
      swapFromId: allocation.value.id,
      swapToId: route.query.swapToId,
    },
  });
};
</script>

<i18n lang="json">
{
  "en": {
    "returnOverview": "Return overview",
    "back": "return to upcoming handovers",
    "next": "next"
  },
  "de": {
    "back": "Zurück zur Übergabeliste",
    "next": "Weiter",
    "returnOverview": "Rückgabeübersicht"
  },
  "es": {
    "returnOverview": "Vista general de la devolución",
    "back": "volver a entregas y devoluciones",
    "next": "siguiente"
  }
}
</i18n>
